import { createContext, useContext } from 'react'
import type { Me } from './api'

/** The account the user is acting as (their own; operators may switch) plus who they are. */
export type Session = { account: string; setAccount: (a: string) => void; me?: Me }
export const SessionContext = createContext<Session>({ account: '', setAccount: () => {} })
export const useSession = () => useContext(SessionContext)

export function loadAccount(): string {
  try { return localStorage.getItem('argo.account') || '' } catch { return '' }
}
export function saveAccount(a: string) {
  try { localStorage.setItem('argo.account', a) } catch { /* ignore */ }
}
